module.exports = __webpack_public_path__ + "static/img/signet-us.beb0b7cc.png";